module.exports = __webpack_public_path__ + "img/5. WETLINE and brush.jpg";